import { cn } from '../../lib/utils';

interface CharacterCountHintProps {
  text: string;
  className?: string;
}

/** Figma "feedback message": right-aligned 12px muted helper under a field. */
export function CharacterCountHint({
  text,
  className,
}: CharacterCountHintProps) {
  return (
    <div
      className={cn(
        'text-right text-xs font-normal leading-4 tabular-nums text-seeker-400',
        className,
      )}
    >
      {text}
    </div>
  );
}

/** "25 characters left" copy used under length-limited fields. */
export function charactersLeft(value: string, max: number): string {
  const remaining = Math.max(0, max - value.length);
  return `${remaining} ${remaining === 1 ? 'character' : 'characters'} left`;
}
